import * as THREE from 'three'

const currentViewport = new THREE.Vector4()

/**
 * Returns the active WebGL viewport size in drawing-buffer pixels.
 */
export function getRendererViewportDrawingBufferSize(
  renderer: THREE.WebGLRenderer,
  target: THREE.Vector2
): THREE.Vector2 {
  if (typeof renderer.getViewport === 'function') {
    const viewport = renderer.getViewport(currentViewport)
    if (
      Number.isFinite(viewport.z) &&
      Number.isFinite(viewport.w) &&
      viewport.z > 0 &&
      viewport.w > 0
    ) {
      const pixelRatio = normalizePixelRatio(renderer.getPixelRatio?.() ?? 1)
      return target.set(
        Math.max(1, Math.round(viewport.z * pixelRatio)),
        Math.max(1, Math.round(viewport.w * pixelRatio))
      )
    }
  }

  return renderer.getDrawingBufferSize(target)
}

function normalizePixelRatio(pixelRatio: number): number {
  return Number.isFinite(pixelRatio) && pixelRatio > 0 ? pixelRatio : 1
}
